<div class="layout-col full">
  @if (item$ | async; as item) {
    @if (item.productionRoute) {
      <!-- Assigned Route / Status -->
      @if ((item$ | async)?.productionRoute; as productionRoute) {
        <div class="flex-none layout-row gap-sm p-sm">
          @for (segment of productionRoute.sequence; track segment) {
            <div
              class="layout-row place-start-center gap-xs segment"
              [matBadge]="'!'"
              [matBadgeHidden]="segment?.validationState === ValidationState.VALIDATED"
              [matBadgeColor]="'warn'"
              [matBadgeOverlap]="true"
            >
              <mat-icon [color]="'primary'">{{ segmentIcon(segment) }}</mat-icon>
              <span class="mat-caption">{{ segment?.workCenterNumber }}</span>
            </div>
          }
        </div>
      }
    }
    @if (!item.productionRoute) {
      @if (item.processPlanId) {
        <div class="flex layout-row place-start-center gap-sm">
          <mat-icon color="warn">error_outline</mat-icon>
          <div class="layout-col">
            <span>{{ 'ItemManufacturingStatus.no-route' | translate }}</span>
          </div>
        </div>
      }
      @if (!item.processPlanId) {
        <div class="flex layout-row place-start-center gap-sm">
          <mat-icon color="warn">error_outline</mat-icon>
          <span>{{ 'ItemManufacturingStatus.no-plan' | translate }}</span>
        </div>
      }
    }
  }
</div>
